import { US_STATES } from './constants';

const str = (v) => {
  if (v === null || v === undefined) return '';
  return String(v).trim();
};

/**
 * Resolve displayable US state from API shapes: string name, nested object, or state_id.
 */
export function resolveStateDisplay(entity) {
  if (!entity || typeof entity !== 'object') return '';

  const addr = entity.address || {};

  const raw =
    entity.state ??
    addr.state ??
    entity.address_state;

  if (raw && typeof raw === 'object') {
    if (raw.name) return str(raw.name);
    if (raw.state_name) return str(raw.state_name);
    if (raw.label) return str(raw.label);
  }
  if (typeof raw === 'string' && raw) return str(raw);

  const sid =
    entity.state_id ??
    addr.state_id ??
    entity.address_state_id;

  if (sid === null || sid === undefined || sid === '') return '';

  const n = typeof sid === 'string' && /^\d+$/.test(sid.trim()) ? parseInt(sid, 10) : Number(sid);
  if (Number.isNaN(n)) return '';

  const found = US_STATES.find((s) => s.id === n);
  return found?.name ? str(found.name) : '';
}

/**
 * Detail view: street line(s), then one line "City, State, Zip" (comma-separated).
 */
export function buildDetailAddressLines({ line1, line2, city, stateDisplay, zip }) {
  const l1 = str(line1);
  const l2 = str(line2);
  const c = str(city);
  const st = str(stateDisplay);
  const z = str(zip);
  const locality = [c, st, z].filter(Boolean).join(', ');
  const lines = [];
  if (l1) lines.push(l1);
  if (l2) lines.push(l2);
  if (locality) lines.push(locality);
  return lines.length > 0 ? lines : ['N/A'];
}
